export const MODAL_TYPES = {
    PREFERENCE_CENTER_MODAL: 'PREFERENCE_CENTER_MODAL',
    AI_ASSISTANT_CONSENT_MODAL: 'AI_ASSISTANT_CONSENT_MODAL',
    AI_ASSISTANT_LOGIN_MODAL: 'AI_ASSISTANT_LOGIN_MODAL',
    AI_ASSISTANT_MICROPHONE_PERMISSION_MODAL: 'AI_ASSISTANT_MICROPHONE_PERMISSION_MODAL',
    AI_ASSISTANT_MICROPHONE_DENIED_MODAL: 'AI_ASSISTANT_MICROPHONE_DENIED_MODAL',
    LTE_CONNECTION_GUIDE_ERROR_MODAL: 'LTE_CONNECTION_GUIDE_ERROR_MODAL',
    WIFI_CONNECTION_GUIDE_BLE_POPUP: 'WIFI_CONNECTION_GUIDE_BLE_POPUP',
    CONNECTION_GUIDE_RECOMMENDATIONS_MODAL: 'CONNECTION_GUIDE_RECOMMENDATIONS_MODAL',
    BARCODE_SCANNER_MODAL: 'BARCODE_SCANNER_MODAL',
    RELEASE_NOTES_MODAL: 'RELEASE_NOTES_MODAL',
    EXPERIENCE_SCORE_CALIBRATION_MODAL: 'EXPERIENCE_SCORE_CALIBRATION_MODAL',
    EXPERIENCE_SCORE_UWM_MODAL: 'EXPERIENCE_SCORE_UWM_MODAL',
    EXPERIENCE_INSIGHTS_CONSENT_MODAL: 'EXPERIENCE_INSIGHTS_CONSENT_MODAL',
    USAGE_CONSENTS_MODAL: 'USAGE_CONSENTS_MODAL',
    USAGE_MODAL: 'USAGE_MODAL',
    USAGE_SELECT_STICK_MODAL: 'USAGE_PAGE_SELECT_STICK_MODAL',
    USAGE_UWM_MODAL: 'USAGE_UWM_MODAL',
    CLUB_PAGE_QUIZ_MODAL: 'CLUB_PAGE_QUIZ_MODAL',
    CLUB_PAGE_PUZZLE_MODAL: 'CLUB_PAGE_PUZZLE_MODAL',
    CLUB_PAGE_ARTICLE_MODAL: 'CLUB_PAGE_ARTICLE_MODAL',
    CLUB_PAGE_STORIES: 'CLUB_PAGE_STORIES',
    CLUB_PAGE_PROMPT_COMPLETED: 'CLUB_PAGE_PROMPT_COMPLETED',
    CLUB_PAGE_PROMPT_REWARDS: 'CLUB_PAGE_PROMPT_REWARDS',
    CLUB_PAGE_REWARD_CARD_MODAL: 'CLUB_PAGE_REWARD_CARD_MODAL',
    CLUB_PAGE_REWARD_LIST_MODAL: 'CLUB_PAGE_REWARD_LIST_MODAL',
    CLUB_PAGE_FEEDBACK_MODAL: 'CLUB_PAGE_FEEDBACK_MODAL',
    HIGH_TEMPERATURE_MODAL: 'HIGH_TEMPERATURE_MODAL',
    NOTIFICATIONS_FEEDBACK_MODAL: 'NOTIFICATIONS_FEEDBACK_MODAL',
    FEEDBACK_MOBILE_UWM_MODAL: 'FEEDBACK_MOBILE_UWM_MODAL',
    ORION_FEEDBACK_UWM_MODAL: 'ORION_FEEDBACK_UWM_MODAL',
    CLUB_PAGE_REPORT_MODAL: 'CLUB_PAGE_REPORT_MODAL',
    DEVICE_SETTINGS_ABOUT_DEVICE_INFO_MODAL: 'DEVICE_SETTINGS_ABOUT_DEVICE_INFO_MODAL',
    DEVICE_SETTINGS_LOCATION_MODAL: 'DEVICE_SETTINGS_LOCATION_MODAL',
    SOFTWARE_UPDATE_COMPLETE: 'SOFTWARE_UPDATE_COMPLETE',
    CREDENTIALS_MODAL: 'CREDENTIALS_MODAL',
    SOCIALS_MODAL: 'SOCIALS_MODAL',
    STORES_MODAL: 'STORES_MODAL',
    CONTACT_US_MODAL: 'CONTACT_US_MODAL',
    FORGOT_PASSWORD_MODAL: 'FORGOT_PASSWORD_MODAL',
    RETAIL_FEEDBACK_MODAL: 'RETAIL_FEEDBACK_MODAL',
    RECONNECT_GUIDE_MODAL: 'RECONNECT_GUIDE_MODAL',
    RESTART_DEVICE_MODAL: 'RESTART_DEVICE_MODAL',
    TIPS_AND_TUTORIALS_MODAL: 'TIPS_AND_TUTORIALS_MODAL',
    TIPS_AND_TUTORIALS_MEDIA_MODAL: 'TIPS_AND_TUTORIALS_MEDIA_MODAL',
};
